<template>
  <div class="employee-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "employeeBase",
};
</script>
